import styled from 'styled-components'

export const DetailsMapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 10px;

  .compare-accordion {
    margin: 5px 0;
    box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);
  }
`
